import { useCallback } from "react";

import { useSecureMode } from "@hooks/use-secure-mode";

import { openExternalUrl } from "./external-link.helpers";

export const useExternalLink = ({ allowInSecureMode = false } = {}) => {
  const secureMode = useSecureMode();
  const blocked = secureMode && !allowInSecureMode;

  const open = useCallback(
    (url, options) => {
      if (blocked) {
        return;
      }

      openExternalUrl(url, options);
    },
    [blocked],
  );

  return { blocked, open };
};
